export default __webpack_public_path__ + "static/media/diagram-ko-desktop.beefb8c1.jpg";